"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("./constants");

/**
 * Sets the theme names in the store
 * @param themes
 */
var setThemesInStore = function setThemesInStore(themes) {
  if (window && window.sessionStorage) {
    sessionStorage.setItem(_constants.CX_THEMES, JSON.stringify(themes));
  }
};

var _default = setThemesInStore;
exports.default = _default;